document.addEventListener('DOMContentLoaded', () => {
  const expandable = document.querySelector('.js-howto-expandable');
  if (!expandable) return;

  const button = expandable.querySelector('.hs-howto__read-more');
  const moreLabel = expandable.querySelector('.hs-howto__read-more-label');
  const lessLabel = expandable.querySelector('.hs-howto__read-less-label');
  const parentCard = expandable.closest('.hs-howto__card');

  if (button) {
    button.addEventListener('click', () => {
      const isExpanded = expandable.classList.toggle('is-expanded');
      
      if (parentCard) {
        parentCard.classList.toggle('is-card-expanded', isExpanded);
      }

      button.setAttribute('aria-expanded', isExpanded);

      if (isExpanded) {
        moreLabel.style.display = 'none';
        lessLabel.style.display = 'inline';
      } else {
        moreLabel.style.display = 'inline';
        lessLabel.style.display = 'none';
      }
    });
  }
});